import React from "react";
import { motion } from "framer-motion";

const StatusDashboard = ({ menu_list, total_Count }) => {
  const filteredData = menu_list?.filter((item) => item.value !== "all_task");

  const total = filteredData?.reduce((sum, item) => sum + item.count, 0);

  const percentages = filteredData?.map((item) => (total > 0 ? (item.count / total) * 100 : 0));

  const totalProjects = menu_list?.find((d) => d.value === "all_task")?.count || total;
  return (
    <>
      <div className="min-w-0 grow border border-gray-200 rounded-md mt-2 flex items-center">
        {/* Left Section */}
        <div className="w-40 border-r border-gray-200 flex flex-col items-center justify-center py-3">
          <div className="text-gray-600 font-semibold text-base mb-1">Total Projects</div>
          <div className="text-[#2999BC] text-3xl font-bold border-2 border-dashed border-[#2999BC] rounded-md px-4 py-1">
            {total_Count}
          </div>
        </div>

        {/* Right Section */}
        <div className="min-w-0 grow p-4">
          {/* Header */}
          <div className="text-gray-600 font-medium mb-2">
            Total Task <span className="font-semibold text-black">{totalProjects}</span>
          </div>

          {/* Animated Bar */}
          <div className="flex h-7 w-full rounded overflow-hidden border border-gray-200">
            {filteredData?.map((item, i) => (
              <motion.div
                key={item.value}
                className="h-full"
                style={{ backgroundColor: item.color }}
                initial={{ width: 0 }}
                animate={{ width: `${percentages[i]}%` }}
                transition={{
                  duration: 0.8,
                  ease: "easeOut",
                  delay: i * 0.1,
                }}
              />
            ))}
          </div>

          {/* Legends */}
          <div className="flex flex-wrap items-center gap-6 mt-3 text-sm text-gray-600">
            {filteredData?.map((item) => (
              <div key={item.value} className="flex items-center gap-2">
                <span className="h-2.5 w-2.5 rounded-full" style={{ backgroundColor: item.color }}></span>
                <span>{item.label}</span>
                <span className="font-semibold text-black">{item.count}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default StatusDashboard;
